import React, { useEffect } from 'react'
import SUI from 'shared/components/ui/SUI'
import Title from 'components/App/Title'
import Tracking from 'components/App/Tracking'
import { record } from 'ducks/tracking/actions'
import SignupPage from './v1/signupPage'
import CustomerInformationPage from './v1/customerInformationPage'
import AddTeamMembersPage from './v1/addTeamMembersPage'
import AcceptInvitePage from './v1/acceptInvitePage'
import FacebookPageSelectionPage from './v1/facebookPageSelectionPage'
import OnboardingLayout from './layout'

// shopify
import ShopifyEmailPage from './shopify/emailPage'
import ShopifyUserPage from './shopify/userPage'
import ShopifyCompanyPage from './shopify/companyPage'
import ShopifyTrialPage from './shopify/trialPage'

// v2
import V2SignupPage from './v2/signupPage'
import V2CompanyPage from './v2/companyPage'
import V2OwnerPage from './v2/ownerPage'
import V2PasswordPage from './v2/passwordPage'
import V2VerificationPage from './v2/verificationPage'
import V2CompletionPage from './v2/completionPage'

// v3
import V3SignupPage from './v3/signupPage'
import V3EmailPage from './v3/emailPage'
import V3CompanyPage from './v3/companyPage'
import V3VerificationPage from './v3/verificationPage'

// v4
import V4EmailPage from './v4/emailPage'
import V4UserPage from './v4/userPage'
import V4CompanyPage from './v4/companyPage'
import V4VerificationPage from './v4/verificationPage'

// v5
import V5SignupPage from './v5/signupPage'
import V5EmailPage from './v5/emailPage'
import V5UserPage from './v5/userPage'
import V5CompanyPage from './v5/companyPage'
import V5VerificationPage from './v5/verificationPage'

// v6
import V6SignupPage from './v6/signupPage'
import V6EmailPage from './v6/emailPage'
import V6CompanyPage from './v6/companyPage'
import V6CompanyPage2 from './v6/companyPage2'
import V6VerificationPage from './v6/verificationPage'

const routesMap = {
  // shopify flow
  ShopifyEmailPage,
  ShopifyUserPage,
  ShopifyCompanyPage,
  ShopifyTrialPage,
  // v1 flow
  SignupPage,
  CustomerInformationPage,
  AddTeamMembersPage,
  AcceptInvitePage,
  FacebookPageSelectionPage,
  // v2 flow
  V2SignupPage,
  V2CompanyPage,
  V2OwnerPage,
  V2PasswordPage,
  V2VerificationPage,
  V2CompletionPage,
  // v3 flow
  V3SignupPage,
  V3EmailPage,
  V3CompanyPage,
  V3VerificationPage,
  // v4 flow
  V4EmailPage,
  V4UserPage,
  V4CompanyPage,
  V4VerificationPage,
  // v5 flow
  V5SignupPage,
  V5EmailPage,
  V5UserPage,
  V5CompanyPage,
  V5VerificationPage,
  // v6 flow
  V6SignupPage,
  V6EmailPage,
  V6CompanyPage,
  V6CompanyPage2,
  V6VerificationPage,
}

export default function OnboardingSubapp({
  componentName,
  subprops,
  shouldBootstrap,
  doBootstrapOnboarding,
  layoutVariant,
}) {
  const Page = routesMap[componentName]

  // TODO (jscheel): Need to show loading before google optimize callback is
  // triggered. Problem is, GTM and optimize don't seem to be playing nice as we
  // never actually get the callback. Until then, we can't prevent flickering.

  useEffect(
    () => {
      if (shouldBootstrap) {
        doBootstrapOnboarding()
      }
    },
    [layoutVariant, Page, shouldBootstrap, doBootstrapOnboarding]
  )

  useEffect(
    () => {
      if (Page !== AcceptInvitePage) {
        record()
      }
    },
    [Page]
  )

  return (
    <SUI transparent={false}>
      <OnboardingLayout page={componentName} variant={layoutVariant}>
        <Title />
        <Tracking />
        <Page key={`subapp-${componentName}`} {...subprops} />
      </OnboardingLayout>
    </SUI>
  )
}
